import React, { useState, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setPrintaction } from "../../../../../redux/printstate/printActions";
import baseUrl from "../../../../../api/baseUrl";

function Title({ item, clinicName }: any) {
  const dispatch = useDispatch();
  const [cursor, setcursor] = useState("grab");
  const dragStart = useRef<{ clientX: number; clientY: number; left: number; top: number } | null>(null);

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (dragStart.current == null || item?.title == null) return;
      const { clientX, clientY, left, top } = dragStart.current;
      const newLeft = left + (e.clientX - clientX);
      const newTop = top + (e.clientY - clientY);
      dispatch(setPrintaction({ name: item.title, target: "left", value: newLeft }));
      dispatch(setPrintaction({ name: item.title, target: "top", value: newTop }));
      baseUrl.patch("/clinic/addBillDataGrabPosition", {
        name: item.title,
        left: newLeft,
        top: newTop,
      });
    },
    [dispatch, item?.title]
  );

  const handleMouseUp = useCallback(() => {
    dragStart.current = null;
    setcursor("grab");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  }, [handleMouseMove]);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    if (item?.title == null) return;
    setcursor("grabbing");
    dragStart.current = {
      clientX: e.clientX,
      clientY: e.clientY,
      left: Number(item?.left) || 0,
      top: Number(item?.top) || 0,
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <p
      style={{
        position: "absolute",
        top: item?.top,
        left: item?.left,
        fontSize: item?.size,
        display: item?.show ? "" : "none",
        textTransform: "uppercase",
        fontWeight: 600,
      }}
      className={cursor}
      onMouseDown={handleMouseDown}
    >
      {clinicName}
    </p>
  );
}

export default Title;
